




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Time from '../../utils/time';
@Component({
  name: 'lb-time',
})
export default class extends Vue {
  @Prop({ required: true }) private time!: any;
  @Prop({
    default: 'relative',
    validator(value) {
      return ['relative', 'date', 'datetime'].indexOf(value) > -1;
    },
  }) private type!: string;
  @Prop({ default: '' }) private hash!: string;
  @Prop({ default: 60 }) private interval!: number;

  private date: string = '';
  private timer: any = null;

  public mounted() {
    this.setTime();
    this.timer = setInterval(() => {
      this.setTime();
    }, 1000 * this.interval);
  }

  public beforeDestroy() {
    if (this.timer) { clearInterval(this.timer); }
  }

  private setTime() {
    const type = typeof this.time;
    let time;

    if (type === 'number') {
      const timestamp = this.time.toString().length > 10 ? this.time : this.time * 1000;
      time = (new Date(timestamp)).getTime();
    } else if (type === 'object') {
      time = this.time.getTime();
    } else if (type === 'string') {
      time = (new Date(this.time)).getTime();
    }

    if (this.type === 'relative') {
      this.date = Time(time);
    } else {
      const date = new Date(this.time);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

      if (this.type === 'datetime') {
        this.date = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      } else if (this.type === 'date') {
        this.date = `${year}-${month}-${day}`;
      }
    }
  }
}
